import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../components/SectionHeader';
export function PreQualification() {
  return <div className="pt-32 pb-24 min-h-screen relative overflow-hidden" data-id="element-173">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-navy-light/50 -skew-x-12 translate-x-32 -z-10" data-id="element-174" />

      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-176">
          <SectionHeader eyebrow="Apply Now" title="Pre-Qualification Form" description="Join our global network of verified suppliers. Please provide detailed information about your company's capabilities, certifications, and operational capacity." centered data-id="element-177" />

          <form className="bg-navy-card p-8 md:p-12 rounded-sm border border-navy-border shadow-2xl mt-12" onSubmit={e => e.preventDefault()} data-id="element-178">
            <h3 className="text-xl font-bold text-white mb-6 pb-4 border-b border-navy-border" data-id="element-179">
              Company Information
            </h3>

            <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-180">
              <div data-id="element-181">
                <label htmlFor="companyName" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-182">
                  Company Name *
                </label>
                <input type="text" id="companyName" className="w-full bg-navy border border-navy-border rounded px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="Company Ltd." required data-id="element-183" />
              </div>
              <div data-id="element-184">
                <label htmlFor="website" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-185">
                  Company Website
                </label>
                <input type="url" id="website" className="w-full bg-navy border border-navy-border rounded px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="https://www.example.com" data-id="element-186" />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-187">
              <div data-id="element-188">
                <label htmlFor="country" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-189">
                  Country of Registration *
                </label>
                <input type="text" id="country" className="w-full bg-navy border border-navy-border rounded px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="United Kingdom" required data-id="element-190" />
              </div>
              <div data-id="element-191">
                <label htmlFor="years" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-192">
                  Years in Operation *
                </label>
                <input type="number" id="years" className="w-full bg-navy border border-navy-border rounded px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="e.g. 10" required data-id="element-193" />
              </div>
            </div>

            <h3 className="text-xl font-bold text-white mb-6 pb-4 border-b border-navy-border" data-id="element-194">
              Primary Contact
            </h3>

            <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-195">
              <div data-id="element-196">
                <label htmlFor="firstName" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-197">
                  First Name *
                </label>
                <input type="text" id="firstName" className="w-full bg-navy border border-navy-border rounded px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="John" required data-id="element-198" />
              </div>
              <div data-id="element-199">
                <label htmlFor="lastName" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-200">
                  Last Name *
                </label>
                <input type="text" id="lastName" className="w-full bg-navy border border-navy-border rounded px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="Doe" required data-id="element-201" />
              </div>
            </div>

            <div className="grid md:grid-cols-2 gap-6 mb-10" data-id="element-202">
              <div data-id="element-203">
                <label htmlFor="email" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-204">
                  Business Email *
                </label>
                <input type="email" id="email" className="w-full bg-navy border border-navy-border rounded px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="john@company.com" required data-id="element-205" />
              </div>
              <div data-id="element-206">
                <label htmlFor="phone" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-207">
                  Phone Number *
                </label>
                <input type="tel" id="phone" className="w-full bg-navy border border-navy-border rounded px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="+44 20 7123 4567" required data-id="element-208" />
              </div>
            </div>

            <h3 className="text-xl font-bold text-white mb-6 pb-4 border-b border-navy-border" data-id="element-209">
              Capabilities & Compliance
            </h3>

            <div className="mb-6" data-id="element-210">
              <label htmlFor="sector" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-211">
                Primary Sector *
              </label>
              <select id="sector" className="w-full bg-navy border border-navy-border rounded px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors appearance-none" required data-id="element-212">
                <option value="" data-id="element-213">Select a sector...</option>
                <option value="healthcare" data-id="element-214">Healthcare & Medical</option>
                <option value="infrastructure" data-id="element-215">
                  Infrastructure & Construction
                </option>
                <option value="agriculture" data-id="element-216">Agriculture & Food Security</option>
                <option value="energy" data-id="element-217">Energy & Power</option>
                <option value="technology" data-id="element-218">Technology & Telecoms</option>
                <option value="defense" data-id="element-219">Defense & Security</option>
                <option value="other" data-id="element-220">Other</option>
              </select>
            </div>

            <div className="mb-6" data-id="element-221">
              <label htmlFor="certifications" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-222">
                Key Certifications (e.g., ISO 9001, CE, FDA)
              </label>
              <input type="text" id="certifications" className="w-full bg-navy border border-navy-border rounded px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="List relevant certifications..." data-id="element-223" />
            </div>

            <div className="mb-8" data-id="element-224">
              <label htmlFor="capabilities" className="block text-sm font-medium text-slate-300 mb-2" data-id="element-225">
                Core Capabilities & Products *
              </label>
              <textarea id="capabilities" rows={5} className="w-full bg-navy border border-navy-border rounded px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors resize-none" placeholder="Briefly describe your manufacturing capacity, main product lines, and distribution capabilities..." required data-id="element-226"></textarea>
            </div>

            <button type="submit" className="w-full bg-gold hover:bg-gold-light text-navy font-bold py-4 rounded transition-colors text-lg" data-id="element-227">
              Submit Pre-Qualification Application
            </button>
            <p className="text-xs text-slate-500 text-center mt-4" data-id="element-228">
              By submitting this form, you agree to our verification process.
              Our procurement team will review your details and contact you
              within 3-5 business days.
            </p>
          </form>
        </motion.div>
      </div>
    </div>;
}